import { CTA } from '@/components/atomic/atoms';
import config from '@/config';

const LoginAndPaymentCTA = ({
  disableLoginButton,
  disableProceedToPayment,
  isLoginAndPaymentCTAVisible = true,
  onClickLogin,
  onClickProceedToPayment,
  setIsOpen,
  setRenderTapPaymentWidget
}) =>
  isLoginAndPaymentCTAVisible && (
    <div className='flex gap-2 fixed left-0 bottom-0 bg-white w-full px-2 py-5 z-10'>
      <CTA
        {...{
          buttonColor: 'bg-white border border-brand px-2 py-4 text-brand',
          children: 'Login To Collaborate',
          className: `w-full py-3 text-sm ${
            disableLoginButton ? 'pointer-events-none' : 'pointer-events-auto'
          }`,
          disabled: disableLoginButton,
          onClick: onClickLogin
        }}
      />
      <CTA
        {...{
          buttonColor: 'bg-brand-gradient px-2 py-4 text-white',
          children: 'Proceed To Payment',
          className: `w-full py-3 text-sm ${
            disableProceedToPayment
              ? 'pointer-events-none'
              : 'pointer-events-auto'
          }`,
          disabled: disableProceedToPayment,
          onClick: () => {
            if (!config.isRenderTapPaymentWidget) {
              onClickProceedToPayment();
            } else {
              setIsOpen(true);
              setRenderTapPaymentWidget(true);
            }
          }
        }}
      />
    </div>
  );

export default LoginAndPaymentCTA;
